import React, { useState } from 'react'
import { Collapse } from '@mui/material'
import { styled } from '@mui/material/styles'
import IProjection from './model/IProjection'
import Button from '@mui/material/Button'

const StyledDetail = styled('div')({
  fontSize: '0.8em'
})

const StyledCode = styled('div')({
  fontSize: '0.8em'
})

const StyledNoDetail = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'baseline'
})

const StyledButton = styled(Button)(({ theme }) => ({
  height: theme.spacing(0.5),
  fontSize: '0.8em'
}))

const StyledLabel = styled('label')({
  fontWeight: 'bold'
})

const StyledSection = styled('section')({
  whiteSpace: 'normal',
  wordBreak: 'break-all'
})

const StyledExpandedSection = styled('section')({
  whiteSpace: 'normal',
  wordBreak: 'break-all',
  maxWidth: '50vw'
})

interface IProps {
  item: IProjection
}

const formatWkt = (wkt: string) => wkt.trim().replace(/&quot;/g, '"')

const ProjectionDetails = (props: IProps) => {
  const { item } = props

  const [open, setOpen] = useState(false)

  const changeOpen = (open: boolean) => (event: any) => {
    event.stopPropagation()
    setOpen(open)
  }

  const wkt = formatWkt(item.wkt)
  const proj4String = item.proj4String.trim()

  return (
    <div>
      {open ? (
        <Collapse in={open} timeout="auto" unmountOnExit>
          <div>
            <StyledDetail>
              <StyledLabel>wkt</StyledLabel>
              <StyledExpandedSection>{wkt}</StyledExpandedSection>
            </StyledDetail>

            <StyledDetail>
              <StyledLabel>proj4String</StyledLabel>
              <StyledExpandedSection>
                {proj4String}
                <StyledButton onClick={changeOpen(false)}>less</StyledButton>
              </StyledExpandedSection>
            </StyledDetail>
          </div>
        </Collapse>
      ) : (
        <StyledNoDetail>
          <StyledCode>Code: {item.id}</StyledCode>
          <StyledButton onClick={changeOpen(true)}>more</StyledButton>
        </StyledNoDetail>
      )}
    </div>
  )
}

export default ProjectionDetails
